/**
 * WordPress dependencies.
 */
import { Fragment } from '@wordpress/element';
import { Disabled, BaseControl, TabPanel, PanelBody } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { applyFilters, addFilter } from '@wordpress/hooks';
import { useSelect } from '@wordpress/data';
import { getFragment } from '@wordpress/url';

/**
 * Exteranl dependencies.
 */
import { replace, isEmpty, has, last, merge } from 'lodash';

/**
 * Inner dependencies.
 */
import { getParsedVar } from '../../utils';
import { ColorControl } from '../../../../extensions/controls/color-options';
import '../../../../extensions/store/settings';

const ColorsSettings = ( props ) => {
	const { gStyle, changeSiteOptions, appState } = props;

	const siteOptions = useSelect( ( select ) => {
		return select( 'gutenify/settings' ).getSiteOptions();
	} );
	// console.log( gStyle?.settings );

	let coreStyles = {};
	const _coreSettings = gStyle?.settings ? gStyle.settings : {};
	let gutenifyStyles = {};

	if ( has( siteOptions, 'coreSettings.styles' ) ) {
		coreStyles = siteOptions.coreSettings.styles;
	}

	if ( has( siteOptions, 'settings.styles' ) ) {
		gutenifyStyles = siteOptions.settings.styles;
	}

	const setCoreStyles = ( data ) => {
		changeSiteOptions( merge(
			siteOptions,
			{
				coreSettings: {
					styles: merge( gStyle.styles, data ),
				},
			},
		) );
	};

	const setCoreSettings = ( data ) => {
		changeSiteOptions( merge(
			siteOptions,
			{
				coreSettings: {
					settings: merge( gStyle.settings, data ),
				},
			},
		) );
	};

	const setGutenifyStyles = ( data ) => {
		changeSiteOptions( merge(
			siteOptions,
			{
				settings: {
					styles: merge( gutenifyStyles, data ),
				},
			},
		) );
	};

	const getColorCode = ( colorString ) => {
		let colorCode = colorString;
		if ( ! colorString ) {
			return '';
		}
		if ( colorString.indexOf( 'var(' ) > -1 || colorString.indexOf( 'var:' ) > -1 ) {
			const parsedVar = getParsedVar( colorString );
			if ( ! isEmpty( parsedVar ) ) {
				if ( parsedVar.includes( 'preset' ) && parsedVar.includes( 'color' ) && has( gStyle, 'settings.color.palette.theme' ) ) {
					// console.log( parsedVar );
					const presetThemeColor = gStyle.settings.color.palette.theme.filter( ( themeColor ) => themeColor.slug === last( parsedVar ) );
					const presetWPColor = gStyle.settings.color.palette.default.filter( ( themeColor ) => themeColor.slug === last( parsedVar ) );
					if ( ! isEmpty( presetThemeColor ) ) {
						colorCode = presetThemeColor[ 0 ].color;
					} else if ( ! isEmpty( presetWPColor ) ) {
						colorCode = presetWPColor[ 0 ].color;
					}
				} else if ( parsedVar.includes( 'custom' ) && parsedVar.includes( 'color' ) && has( gStyle, `settings.custom.color.${ last( parsedVar ) }` ) ) {
					colorCode = gStyle.settings.custom.color[ last( parsedVar ) ];
				} else {
					colorCode = '';
				}

				// console.log( colorCode );
			}

			if ( colorCode.indexOf( 'var(' ) > -1 ) {
				colorCode = getColorCode( colorCode );
			}
		}

		return colorCode;
	};

	const colorPalettes = _coreSettings?.color?.palette?.theme ? _coreSettings.color.palette.theme : [];
	const textColor = has( coreStyles, 'color.text' ) ? getColorCode( coreStyles.color.text ) : '';
	const backgroundColor = coreStyles?.color?.background ? getColorCode( coreStyles.color.background ) : '';
	console.log( coreStyles?.color?.background );
	const h1Color = has( coreStyles, 'elements.h1.color.text' ) ? getColorCode( coreStyles.elements.h1.color.text ) : '';
	const buttonBackgroundColor = has( coreStyles, 'blocks.core/button.color.background' ) ? getColorCode( coreStyles.blocks[ 'core/button' ].color.background ) : '';
	const buttonTextColor = has( coreStyles, 'blocks.core/button.color.text' ) ? getColorCode( coreStyles.blocks[ 'core/button' ].color.text ) : '';

	const linkColor = coreStyles?.elements?.link?.color?.text ? getColorCode( coreStyles.elements.link.color.text ) : '';
	// const linkColor = '';

	// console.log( ( gStyle ) );
	console.log( getColorCode( coreStyles?.elements?.link?.color?.text ) );

	return <Disabled isDisabled={ appState.isSettingsDisabled }>
		{ colorPalettes.map( ( palette, index ) => <div className="gutenify-field-wrapper gutenify-field-grid" key={ `color-palettes-${ palette.slug }` }>
			<div className="gutenify-field-label">
				<label htmlFor="primary-color-control">{ `${ palette.name }` }</label>
			</div>
			<div className="gutenify-field-control">
				<ColorControl
					onChange={ ( color ) => {
						const _data = {
							color: {
								palette: {
									theme: [ ...colorPalettes ],
								},
							},
						};
						_data.color.palette.theme[ index ].color = color;
						const data = merge( _coreSettings, _data );
						setCoreSettings( { ...data } );
					} }
					value={ palette.color }
					clearable={ false }
					id="primary-color-control"
				/>

			</div>
		</div> ) }
		<div className="gutenify-field-wrapper gutenify-field-grid">
			<div className="gutenify-field-label">
				<label htmlFor="text-color-control">{ __( 'Text Color' ) }</label>
			</div>
			<div className="gutenify-field-control">
				<ColorControl
					onChange={ ( color ) => {
						const data = merge( coreStyles, {
							color: {
								text: color,
							},
						} );
						setCoreStyles( { ...data } );
					} }
					value={ textColor }
					clearable={ false }
					id="ext-color-control"
				/>

			</div>
		</div>
		<div className="gutenify-field-wrapper gutenify-field-grid">
			<div className="gutenify-field-label">
				<label htmlFor="site-background-color-control">{ __( 'Site Background Color' ) }</label>
			</div>
			<div className="gutenify-field-control">
				<ColorControl
					// label={ __( 'Site Background Color' ) }
					onChange={ ( color ) => {
						const data = merge( coreStyles, {
							color: {
								background: color,
							},
						} );
						setCoreStyles( { ...data } );
					} }
					value={ backgroundColor }
					clearable={ false }
					id="site-background-color-control"
				/>
			</div>
		</div>
		<div className="gutenify-field-wrapper gutenify-field-grid">
			<div className="gutenify-field-label">
				<label htmlFor="site-background-color-control">{ __( 'Heading Color' ) }</label>
			</div>
			<div className="gutenify-field-control">
				<BaseControl help={ __( 'This will change color for H1 to H6 tags.' ) }>
					<ColorControl
						// label={ __( 'Heading Color' ) }
						onChange={ ( color ) => {
							const data = merge( coreStyles, {
								elements: {
									h1: {
										color: {
											text: color,
										},
									},
									h2: {
										color: {
											text: color,
										},
									},
									h3: {
										color: {
											text: color,
										},
									},
									h4: {
										color: {
											text: color,
										},
									},
									h5: {
										color: {
											text: color,
										},
									},
									h6: {
										color: {
											text: color,
										},
									},
								},
							} );
							setCoreStyles( { ...data } );
						} }
						value={ h1Color }
						clearable={ false }
					/>
				</BaseControl>
			</div>
		</div>
		<div className="gutenify-field-wrapper gutenify-field-grid">
			<div className="gutenify-field-label">
				<label htmlFor="site-background-color-control">{ __( 'Button Color' ) }</label>
			</div>
			<div className="gutenify-field-control">
				<TabPanel
					className="gutenify-editor-tab-panel gutenify-editor-tab-ovel"
					activeClass="active-tab"
					tabs={ [
						{
							name: 'button-color-normal',
							title: __( 'Normal' ),
							className: 'gutenify-color-normal-tab',
						},
						{
							name: 'button-color-hover',
							title: __( 'Hover' ),
							className: 'gutenify-color-hover-tab',
						},
					] }
				>
					{ ( tabInner ) => {
						return <>
							{ 'button-color-normal' === tabInner.name && <>
								<ColorControl
									label={ __( 'Button background Color' ) }
									onChange={ ( color ) => {
										const data = merge( coreStyles, {
											blocks: {
												'core/button': {
													color: {
														background: color,
													},
												},
											},
										} );
										setCoreStyles( { ...data } );
									} }
									value={ buttonBackgroundColor }
									clearable={ false }
								/>
								<ColorControl
									label={ __( 'Button Text Color' ) }
									onChange={ ( color ) => {
										const data = merge( coreStyles, {
											blocks: {
												'core/button': {
													color: {
														text: color,
													},
												},
											},
										} );
										setCoreStyles( { ...data } );
									} }
									value={ buttonTextColor }
									clearable={ false }
								/>

							</>
							}
							{ 'button-color-hover' === tabInner.name && <>
								{ applyFilters( 'gutenify--settings--design--colors-button-hover', [], { ...props, setCoreStyles, setGutenifyStyles, getColorCode } ) }
							</> }
						</>;
					} }
				</TabPanel>

			</div>
		</div>
		<div className="gutenify-field-wrapper gutenify-field-grid">
			<div className="gutenify-field-label">
				<label htmlFor="site-background-color-control">{ __( 'Link Color' ) }</label>
			</div>
			<div className="gutenify-field-control">
				<TabPanel
					className="gutenify-editor-tab-panel gutenify-editor-tab-ovel"
					activeClass="active-tab"
					tabs={ [
						{
							name: 'link-color-normal',
							title: __( 'Normal' ),
							className: 'gutenify-color-normal-tab',
						},
						{
							name: 'link-color-hover',
							title: __( 'Hover' ),
							className: 'gutenify-color-hover-tab',
						},
					] }
				>
					{ ( tabInner ) => {
						return <>
							{ 'link-color-normal' === tabInner.name && <>
								<ColorControl
									label={ __( 'Link Color' ) }
									onChange={ ( color ) => {
										const data = merge( coreStyles, {
											elements: {
												link: {
													color: {
														text: color,
													},
												},
											},
										} );
										setCoreStyles( { ...data } );
									} }
									value={ linkColor }
									clearable={ false }
								/>
							</> }
							{ 'link-color-hover' === tabInner.name && <>
								{ applyFilters( 'gutenify--settings--design--colors-link-hover', [], { ...props, setCoreStyles, setGutenifyStyles, getColorCode } ) }
							</> }
						</>;
					} }
				</TabPanel>
			</div>
		</div>
	</Disabled>;
};

addFilter( 'gutenify-admin-settings-design-panel', 'gutenify-admin-settings-design-panel-colors', ( content, props ) => (
	[ ...content, <Fragment key="gutenify-admin-settings-design-panel-colors">
		<PanelBody title={ __( 'Colors' ) } initialOpen={ 'general' === props.activePanel }>
			{ /* <div>{ __( 'Post Type' ) }<p className="description">{ __( 'Choose post types to activate Gutenburg.' ) }</p></div> */ }
			<ColorsSettings { ...props } />
		</PanelBody>
	</Fragment> ]
) );

const gutenifyComingSoonMessageCB = ( content ) => {
	if ( '1' === window._gutenify.pro_license_status ) {
		return content;
	}
	return [
		...content,
		<Fragment key="gutenify-admin-settings-panel-license">
			{ __( 'Coming soon...' ) }
		</Fragment>,
	];
};

addFilter( 'gutenify--settings--design--colors-link-hover', 'gutenify--settings--design--colors-link-hover-coming-soon-message', gutenifyComingSoonMessageCB, 11 );
addFilter( 'gutenify--settings--design--colors-button-hover', 'gutenify--settings--design--colors-button-hover-coming-soon-message', gutenifyComingSoonMessageCB, 11 );
